import { Button, Flex, Modal, ModalProps, Typography } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StopAndRateConversationResult } from '../../prompts/output/stop-and-rate-conversation-result'
import { Campaign } from '../campaign'
import { CampaignTryOutContent } from './campaign-try-out-content'
import { CandidateAttributes } from '../../candidate/components/candidate-attributes'

export type CampaignTryOutProps = ModalProps & {
    campaign: Campaign
}

export function CampaignTryOut({ campaign, ...modalProps }: CampaignTryOutProps) {
    const { t } = useTranslation()
    const [match, setMatch] = useState<StopAndRateConversationResult>()
    const [showScore, setShowScore] = useState(false)

    const handleClose = () => {
        setMatch(undefined)
        setShowScore(false)
        modalProps.onCancel?.({} as never)
    }

    const handleShowScore = (matchResult: StopAndRateConversationResult) => {
        setMatch(matchResult)
        setShowScore(true)
    }

    const handleTryAgain = () => {
        setShowScore(false)
        setMatch(undefined)
    }

    if (showScore) {
        return (
            <Modal
                destroyOnHidden
                {...modalProps}
                onCancel={handleClose}
                title={modalProps.title ?? t('Try out')}
                footer={[
                    <Button
                        key="close"
                        onClick={handleClose}
                    >
                        {t('Close')}
                    </Button>,
                    <Button
                        key="retry"
                        type="primary"
                        onClick={handleTryAgain}
                    >
                        {t('Try again')}
                    </Button>,
                ]}
            >
                <Flex
                    vertical
                    gap="large"
                    className="text-center"
                >
                    <div>
                        <Typography.Title>{(match?.matchScore || 0) >= 70 ? '🏆' : '😐'}</Typography.Title>
                        <Typography.Title
                            level={2}
                            className="m-0"
                        >
                            {match?.matchScore}%
                        </Typography.Title>
                    </div>
                    <CandidateAttributes
                        positive={match?.positiveCandidateAttributes}
                        negative={match?.negativeCandidateAttributes}
                    />
                </Flex>
            </Modal>
        )
    }

    return (
        <Modal
            destroyOnHidden
            {...modalProps}
            onCancel={handleClose}
            title={modalProps.title ?? t('Try me out')}
            width={800}
            footer={null}
        >
            <CampaignTryOutContent
                campaign={campaign}
                onShowScore={handleShowScore}
                onTryAgain={handleTryAgain}
            />
        </Modal>
    )
}
